export default __webpack_public_path__ + "static/media/operator-n.068ff74c.png";